var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{attrs:{"size":"small","type":"border","href":_vm.refSanitize,"disabled":_vm.disabled,"rel":_vm.rel,"target":_vm.target}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }